import * as React from "react";

const SearchIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path d="m27.6 29-6.3-6.3q-.75.6-1.725.95T17.5 24q-2.725 0-4.613-1.887Q11 20.225 11 17.5t1.887-4.613Q14.776 11 17.5 11t4.613 1.887Q24 14.776 24 17.5a6.1 6.1 0 0 1-1.3 3.8l6.3 6.3zm-10.1-7q1.875 0 3.188-1.312Q22 19.375 22 17.5t-1.312-3.187T17.5 13t-3.187 1.313T13 17.5t1.313 3.188T17.5 22"></path>
    </svg>
);

export default SearchIconSVG;
